<template>
  <div class="post-comment-management">
    <!-- 顶部筛选区域 -->
    <div class="filter-bar">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="帖子ID">
          <el-input
            v-model="filterForm.fposts_app_id"
            placeholder="帖子ID"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="帖子名称">
          <el-input
            v-model="filterForm.post_name"
            placeholder="帖子名称"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="用户ID">
          <el-input
            v-model="filterForm.user_id"
            placeholder="用户ID"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="用户昵称">
          <el-input
            v-model="filterForm.user_nickname"
            placeholder="用户昵称"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="评论内容">
          <el-input
            v-model="filterForm.comment_content"
            placeholder="评论内容"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="状态">
          <el-select
            v-model="filterForm.status"
            placeholder="全部状态"
            clearable
          >
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="审核通过" :value="1"></el-option>
            <el-option label="审核不通过" :value="2"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetFilter">重置</el-button>
          <el-button type="success" @click="handleAdd">添加评论</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <!-- 评论列表 -->
    <el-table :data="commentList" border style="width: 100%; margin-top: 20px;">
      <el-table-column prop="comment_id" label="ID" width="80"></el-table-column>
      <el-table-column prop="name" label="评论内容"></el-table-column>
      <el-table-column prop="fposts_app_id" label="帖子ID" width="100"></el-table-column>
      <el-table-column prop="post_name" label="帖子名称" width="150"></el-table-column>
      <el-table-column prop="user_id" label="用户ID" width="100"></el-table-column>
      <el-table-column prop="user_nickname" label="用户名称" width="150"></el-table-column>
      <el-table-column label="状态" width="120">
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.status)">
            {{ getStatusText(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="like" label="点赞数" width="100"></el-table-column>
      <el-table-column prop="sort" label="排序" width="80"></el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-button 
            size="mini" 
            v-if="scope.row.status === 0"
            type="primary"
            @click="handleApprove(scope.row)"
          >
            审核
          </el-button>
          <el-button 
            size="mini" 
            @click="handleEdit(scope.row)"
          >
            编辑
          </el-button>
          <el-button 
            size="mini" 
            type="danger" 
            @click="handleDelete(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.current"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
      style="margin-top: 20px;"
    ></el-pagination>
    
    <!-- 添加/编辑对话框 -->
      <el-dialog title="审核评论" :visible.sync="approveDialogVisible" width="30%">
    <el-form :model="approveForm" label-width="80px">
      <el-form-item label="审核结果">
        <el-radio-group v-model="approveForm.status">
          <el-radio :label="1">审核通过</el-radio>
          <el-radio :label="2">审核不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" v-if="approveForm.status === 2">
        <el-input
          type="textarea"
          v-model="approveForm.remark"
          placeholder="请输入不通过原因（可选）"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="approveDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitApprove">确 定</el-button>
    </div>
  </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%">
      <el-form :model="commentForm" :rules="rules" ref="commentForm" label-width="100px">
        <el-form-item label="评论内容" prop="name">
          <el-input v-model="commentForm.name" placeholder="请输入评论内容"></el-input>
        </el-form-item>
        <el-form-item label="帖子ID" prop="fposts_app_id">
          <el-input v-model="commentForm.fposts_app_id" placeholder="请输入帖子ID"></el-input>
        </el-form-item>
        <el-form-item label="用户ID" prop="user_id">
          <el-input v-model="commentForm.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="commentForm.status" placeholder="请选择状态">
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="审核通过" :value="1"></el-option>
            <el-option label="审核不通过" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="点赞数" prop="like">
          <el-input-number v-model="commentForm.like" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="commentForm.sort" :min="0"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Fposts_appApi from "@/api/fposts_app.js";

export default {
  data() {
    return {
          approveDialogVisible: false,
      approveForm: {
        comment_id: '',
        status: 1, // 1通过 2不通过
        remark: ''
      },
      filterForm: {
        fposts_app_id: '',
        post_name: '',
        user_id: '',
        user_nickname: '',
        comment_content: '',
        status: null
      },
      commentList: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '添加评论',
      commentForm: {
        post_comment_id: '',
        name: '',
        fposts_app_id: '',
        user_id: '',
        status: 1,
        like: 0,
        sort: 100
      },
      rules: {
        name: [{ required: true, message: '请输入评论内容', trigger: 'blur' }],
        fposts_app_id: [{ required: true, message: '请输入帖子ID', trigger: 'blur' }],
        user_id: [{ required: true, message: '请输入用户ID', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getCommentList();
  },
  methods: {
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '待审核',
        1: '审核通过',
        2: '审核不通过'
      };
      return statusMap[status] || '未知状态';
    },
     handleApprove(row) {
      this.approveForm = {
        comment_id: row.comment_id,
        status: 1,
        remark: ''
      };
      console.log(this.approveForm);
      
      this.approveDialogVisible = true;
    },
    
    // 提交审核
    submitApprove() {
      Fposts_appApi.approveComment(this.approveForm).then(res => {
        if (res.code === 1) {
          this.$message.success(res.msg || '审核成功');
          this.approveDialogVisible = false;
          this.getCommentList();
        } else {
          this.$message.error(res.msg || '审核失败');
        }
      }).catch(err => {
        console.error('审核失败:', err);
        this.$message.error('审核失败');
      });
    },
    
    // 获取状态标签类型
    getStatusTagType(status) {
      const typeMap = {
        0: 'warning',
        1: 'success',
        2: 'danger'
      };
      return typeMap[status] || '';
    },
    
    // 获取评论列表
    getCommentList() {
  const params = {
    ...this.filterForm,
    page: this.pagination.current,
    size: this.pagination.size
  };
  
  Fposts_appApi.commentList(params).then(res => {
    if (res.code === 1) {
      // 修改这里：从 res.data.list 改为 res.data
      this.commentList = res.data.list || [];  // 确保获取的是数组
      this.pagination.total = res.data.total || 0;
    } else {
      this.$message.error(res.msg || '获取评论列表失败');
    }
  }).catch(err => {
    console.error('获取评论列表失败:', err);
    this.$message.error('获取评论列表失败');
  });
},
    
    // 搜索
    handleSearch() {
      this.pagination.current = 1;
      this.getCommentList();
    },
    
    // 重置筛选条件
    resetFilter() {
      this.filterForm = {
        fposts_app_id: '',
        post_name: '',
        user_id: '',
        user_nickname: '',
        comment_content: '',
        status: null
      };
      this.pagination.current = 1;
      this.getCommentList();
    },
    
    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.size = val;
      this.getCommentList();
    },
    
    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getCommentList();
    },
    
    // 添加评论
    handleAdd() {
      this.dialogTitle = '添加评论';
      this.commentForm = {
        comment_id: '',
        name: '',
        fposts_app_id: '',
        user_id: '',
        status: 1,
        like: 0,
        sort: 100
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.commentForm && this.$refs.commentForm.clearValidate();
      });
    },
    
    // 编辑评论
    handleEdit(row) {
      this.dialogTitle = '编辑评论';
      this.commentForm = { ...row };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.commentForm && this.$refs.commentForm.clearValidate();
      });
    },
    
   
    
    // 提交表单
    submitForm() {
      this.$refs.commentForm.validate(valid => {
        if (valid) {
          const api = this.commentForm.comment_id 
            ? 'editComment' 
            : 'addComment';
            
          Fposts_appApi[api](this.commentForm).then(res => {
            if (res.code === 1) {
              this.$message.success(res.msg || '操作成功');
              this.dialogVisible = false;
              this.getCommentList();
            } else {
              this.$message.error(res.msg || '操作失败');
            }
          }).catch(err => {
            console.error('操作失败:', err);
            this.$message.error('操作失败');
          });
        }
      });
    },
    
    // 删除评论
    handleDelete(row) {
      this.$confirm('确认删除该评论吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Fposts_appApi.deleteComment({ 
          comment_id: row.comment_id 
        }).then(res => {
          if (res.code === 1) {
            this.$message.success(res.msg || '删除成功');
            this.getCommentList();
          } else {
            this.$message.error(res.msg || '删除失败');
          }
        }).catch(err => {
          console.error('删除失败:', err);
          this.$message.error('删除失败');
        });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    }
  }
}
</script>

<style scoped>
.post-comment-management {
  padding: 20px;
}
.filter-bar {
  margin-bottom: 20px;
}
.filter-form {
  display: flex;
  flex-wrap: wrap;
}
.el-form-item {
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/fposts_app/commment/index.vue